import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries } from "@/api/http-common";

export function callApiLayDanhSachNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHOM_CHUC_VU.NHOM_CHUC_VU_PAGING}${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.NHOM_CHUC_VU.TAO_MOI}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayChiTietNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHOM_CHUC_VU.NHOM_CHUC_VU_CHI_TIET_ID}${parseInt(
        payload.chucVuId
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiCapNhatNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.NHOM_CHUC_VU.NHOM_CHUC_VU_CAP_NHAT}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiXoaNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHOM_CHUC_VU.NHOM_CHUC_VU_XOA}${payload.ID}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
